import { server } from '../config';
import styles from '../styles/Accordion.module.scss';
import styles2 from '../styles/LeadsHelpful.module.scss';

const linkRedirection = {
  1: async (url) => {
    const shareapp = { url };
    window.JdLiteInterface.nativeDeepLinking(JSON.stringify(shareapp));
  },
  2: (url) => {
    window.location.href = url;
  },
  3: (url) => {
    const shareapp = { type: 'deeplinkJD' };
    shareapp.shareText = 'Redirection';
    shareapp.shareUrl = url;
    const shareappstr = JSON.stringify(shareapp);
    window.webkit.messageHandlers.callbackHandler.postMessage(shareappstr);
  },
};

export const isProduction = () => {
  const hostname = window.location.hostname || '';
  return hostname.includes('cs.justdial.com') || hostname.includes('234');
};

export function setCookie(name, value) {
  const domain = isProduction() ? '.justdial.com' : window.location.hostname;
  document.cookie = `${name}=${value};domain=${domain};path=/`;
}

export function setSidInCookies(sid) {
  const finalSid = sid.indexOf('%') === -1 ? encodeURIComponent(sid) : sid;
  setCookie('sid', finalSid);
  return finalSid;
}

// Get cookie value by name
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export const getQueryVariable = (variable) => {
  const query = decodeURIComponent(window.location.search.substring(1));
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return '';
};

export function getSourceValue() {
  const source = getQueryVariable('source') || getCookie('source') || '2';
  const sourceArray = source?.includes('[') ? JSON.parse(source) : source;

  if (Array.isArray(sourceArray) && sourceArray && sourceArray?.length > 0) {
    return sourceArray && sourceArray?.length > 0 ? sourceArray?.[sourceArray.length - 1] : '3';
  }
  const sourceSplitArr = source && source.length > 0 ? source.split(',') : [];
  const resp = source && source.length > 0 ? sourceSplitArr?.[sourceSplitArr.length - 1] : '2';
  return resp;
}

export const clickTracker = async (li, ll) => {
  if (window.location.host.includes('cs.justdial.com') || window.location.host.includes('192.168.8.234')) {
    try {
      const source = getSourceValue();
      const version = getQueryVariable('version') || '1';
      const sid = getCookie('sid') || '';
      const encodedll = encodeURI(ll);
      const encodedli = encodeURI(li);

      const url = `${server.apiURL}csportal/sendClickTracker`;
      const paramsBody = {
        source,
        version,
        sid,
        encodedll,
        encodedli,
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(paramsBody),
        credentials: 'include',
      };
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      return data;
    } catch (e) {
      console.log('error ', e);
      return { errorCode: 1 };
    }
  } else {
    return null;
  }
};

export const getTextWithNoSpace = (str, separaterVal = '') => {
  return str ? str?.replace(/\s/g, separaterVal) : str || '';
};

export const handleRedirection = async (source, url, web = false) => {
  try {
    const finalUrl = `${url}&source=${source}`;

    if (['51', 51].includes(source)) {
      const logjson = JSON.stringify({ action: 'openurl', url });
      window.JdLiteInterface.verticalHandler(logjson);
      return;
    }
    // if (['53', 53].includes(source)) {
    //   const shareapp = { type: 'openSafariBrowser' };
    //   shareapp.shareText = 'Redirection';
    //   shareapp.shareUrl = finalUrl;
    //   const shareappstr = JSON.stringify(shareapp);
    //   window.webkit.messageHandlers.callbackHandler.postMessage(shareappstr);
    //   return;
    // }

    if ((web && source === '1') || !linkRedirection[source]) {
      window.location.href = finalUrl;
    } else if (['53', 53].includes(source)) {
      const shareapp = { type: 'openSafariBrowser' };
      shareapp.shareText = 'Redirection';
      shareapp.shareUrl = finalUrl;
      const shareappstr = JSON.stringify(shareapp);
      window.webkit.messageHandlers.callbackHandler.postMessage(shareappstr);
    } else {
      linkRedirection[source](finalUrl);
    }
  } catch (err) {
    window.location.href = `${url}&source=${source}`;
  }
};

export function clearLocalStorage() {
  localStorage.removeItem('csPortalType');
  localStorage.removeItem('selectedBusiness');
}

export function ChangeFirstLetterCapital(value) {
  try {
    return value[0].toUpperCase() + value.slice(1);
  } catch {
    return value;
  }
}

const getUserType = {
  paid: 'PaidUser',
  expiredLong: 'free/expiredm3m',
  expiredShort: 'free/expiredl3m',
  free: 'NonPaid',
  user: 'CSPortalUser',
};

const userTypeTrackerObj = {
  report: 'issue_reportanissue',
  wantlisting: 'issue_newlisting',
  transact: 'User_mytransaction',
  grievance: 'User_grievancepopup',
};

const trackerObj = {
  ECS: 'ecs',
  Leads: 'leads',
  'Edit-my-Business': 'editbusiness',
  'Activation-Deactivation': 'activation',
  Payments: 'payments',
  Others: 'others',
  'Contract-Information': 'contract',
  'Website-App-Related': 'websiteapp',
  'Banner-JDRR': 'banner',
  omni: 'omni',
  'JD-Pay': 'jdpay',
  grievanceRedressal: 'grievance',
  wantLeads: 'wantleads',
  report: 'report',
  wantlisting: 'wantlisting',
  transact: 'transact',
  grievance: 'grievance',
  jdrrCertificate: 'jdrrCertificate',
};

const webSource = [0, '0', 7, '7', 77, '77', 27, '27'];

const andriodSource = [1, '1', 21, '21', 51, '51', 81, '81'];
const iosSource = [3, '3', 23, '23', 53, '53', 83, '83', '43', 43];
const touchSource = [2, '2', 22, '22'];
export const freeExpiredContractType = ['free', 'expiredLong'];
export const paidContractType = ['expiredShort', 'paid'];

const trackUserType = {
  paid: 'paid',
  expiredLong: 'nonpaid_M3M',
  expiredShort: 'paid_L3M',
  free: 'nonpaid',
  user: 'user',
};

export const helpfulObj = [
  {
    id: 0,
    val: true,
    icon: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/thumb_up.svg',
    isActive: false,
    alt: 'thumb_up',
    text: 'Was helpful',
    color: styles2.color56A,
  },
  {
    id: 1,
    val: false,
    icon: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/thumb_down.svg',
    isActive: false,
    alt: 'thumb_down',
    text: 'Not relevant',
    color: styles2.colorEB5,
  },
];

export const getProjectId = () => (window.location.pathname.includes('genio') ? 'genio' : 'csportal');

export const isMaxCharLimit = (comment) => {
  return comment?.trim()?.length >= 1500;
};

const maxCharLimitErrMsg = 'Your comment is too long. Please keep it short!';

export const checkEngChars = (comment) => {
  const projectId = getProjectId();
  const englishOnlyRegex = /^[a-zA-Z\s.,@:'"\-!?0-9]*$/;
  const isEnglishOnly = projectId === 'csportal' ? true : englishOnlyRegex.test(comment.trim());
  return isEnglishOnly;
};

export const CheckingValidComment = (value, len = 3) => {
  if (isMaxCharLimit(value)) {
    return false;
  }
  let isValid = true;
  let isValidComment = true;

  if (value.trim().length === 3) {
    const regex = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~0-9]/;
    isValid = !regex.test(value.trim());
  } else if (value.trim().length > 3) {
    const regex = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
    isValid = !regex.test(value.trim().slice(0, 3));
    const pattern = /[`!#$%^&*()_+=[\]{};'"\\|<>/~]/;
    isValidComment = !pattern.test(value.trim());
  }

  return value.trim().length >= len && isValid && isValidComment && checkEngChars(value);
};

export const getNonEnglishCharMsg = (comment) => {
  if (isMaxCharLimit(comment)) {
    return maxCharLimitErrMsg;
  }
  const hasNonEnglishChars = /[^a-zA-Z\s`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~0-9]/.test(comment);
  let errMsg = '';
  if (hasNonEnglishChars) {
    errMsg = 'Only English is allowed while raising a ticket. Please modify your input.';
  }
  return errMsg;
};

export const getCommentErrorMsg = (comment, categoryTktFlag = 0) => {
  if (isMaxCharLimit(comment)) {
    return maxCharLimitErrMsg;
  }
  const projectId = getProjectId();
  let finalErrMsg = '';
  const initialErrMsg =
    projectId === 'genio' && categoryTktFlag === 1
      ? `Only these special characters are allowed @ - : , ? .`
      : 'Please avoid special characters.';

  if (projectId === 'csportal') {
    finalErrMsg = initialErrMsg;
  } else {
    const hasNonEnglishChars = /[^a-zA-Z\s]/.test(comment);
    const hasSpecialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~0-9]/.test(comment);

    if (hasNonEnglishChars && !hasSpecialChars) {
      finalErrMsg = 'Only English is allowed while raising a ticket. Please modify your input.';
    } else {
      finalErrMsg = initialErrMsg;
    }
  }

  return finalErrMsg;
};

export const getPaymentsSubEventType = {
  1: 'invoicedown',
  2: 'invoiceedit',
  3: 'invoicegst',
  4: 'trffunds',
  5: 'preinvoice',
  6: 'areapositioninfo',
  7: 'contractinactive',
  8: 'stopcheque',
};
export const getSubEventType = {
  1: 'FAQ_noleads',
  2: 'FAQ_lessleads',
  3: 'FAQ_irrelevantleads',
  4: 'FAQ_arealeads',
  5: 'FAQ_reportleads',
  6: 'FAQ_convertleads',
  7: 'FAQ_delayleads',
  8: 'FAQ_increaseleads',
  9: 'FAQ_accessleads',
};
export const alertDuration = 3000;
export const helpfulObjData = [
  {
    id: 0,
    val: true,
    icon: styles.Accordion__ThumbUp,
    isActive: false,
  },
  {
    id: 1,
    val: false,
    icon: styles.Accordion__ThumbDown,
    isActive: false,
  },
];

export const callSidFunction = async (source = 2) => {
  const redirectUrl = `${encodeURIComponent(window.location.href)}?createTicket=1`;
  if (webSource.includes(source)) {
    window.location = `https://www.justdial.com/login?redirectionurl=${redirectUrl}`;
  } else if (touchSource.includes(source)) {
    window.location = `https://www.justdial.com/login?redirect=${redirectUrl}&redirectionurl=${redirectUrl}`;
  } else if (andriodSource.includes(source)) {
    // for android
    const logjson = JSON.stringify({ fn: 'nativeLogin', fnc: 'nativeLogin' });
    window.JdLiteInterface.verticalLogin(logjson);
  } else if (iosSource.includes(source)) {
    const logjson = JSON.stringify({ type: 'verticalLogin', fn: 'nativeLogin', fnc: 'nativeLogin' });
    await window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
  }
};

export const ticketFiltersObj = {
  All: 'all',
  Open: 'open',
  'In Progress': 'inprogress',
  Closed: 'closed',
  'Grievance Redressal': 'grievance',
};

export const imageTypesObj = {
  xlsx: 'https://akam.cdn.jdmagicbox.com/images/icontent/sso/excel_icon.svg',
  doc: 'https://akam.cdn.jdmagicbox.com/images/icontent/sso/documnet_icon.svg',
  pdf: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/newdoctor/caht_documenticon.svg',
  mp4: 'https://images.jdmagicbox.com/standard/cs_module/fa2c3dc6e80b56965d8bc76df0911755.jpg',
  docx: 'https://akam.cdn.jdmagicbox.com/images/icontent/sso/documnet_icon.svg',
};
export const getImgSrcUrl = (url) => {
  // eslint-disable-next-line no-useless-escape
  const match = url.match(/\.([a-z0-9]+)(?:[\?#]|$)/i);
  const fileType = match ? match[1] : null;
  const hasFileType = Object.keys(imageTypesObj).includes(fileType);
  return hasFileType ? imageTypesObj[fileType] : url;
};

export const fileAllowedTypes = [
  'image/jpeg',
  'image/png',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
  'video/mp4',
];

export const isNumRegex = (num) => {
  return /^\d+$/.test(num);
};

const notAllowedDomains = [
  'google.com',
  'facebook.com',
  'twitter.com',
  'instagram.com',
  'google.co',
  'facebook.co',
  'twitter.co',
  'instagram.co',
];

export default function getDomainName(link) {
  const domainRegex = /(?:https?:\/\/)?(?:www\d?\.)?(.[^/:]+)/i;
  const matches = link.match(domainRegex);
  if (matches && matches.length > 1) {
    return matches[1];
  }
  return null;
}

export const containsDisallowedDomain = (link) => {
  const domainName = getDomainName(link);
  return notAllowedDomains.some((domain) => domainName?.includes(domain));
};

export const validateURL = (link, type = '') => {
  const pattern =
    /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#-]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
  if (['Web Banner', 'genioContentUrl'].includes(type)) {
    return pattern.test(link);
  }
  return pattern.test(link) && (link.startsWith('http://') || link.startsWith('https://'));
};

export const CheckingValidSearch = (value) => {
  let isValid = true;

  if (value?.trim()) {
    const regex = /[`!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?~]/;
    isValid = !regex.test(value.trim());
  }
  return isValid;
};

export const getFaqPageType = {
  'Activation-Deactivation': 'activation',
  'Edit-my-Business': 'editbusiness',
  'Website-App-Related': 'webapp',
  'JD-Pay': 'jdpay',
};

export const mobileBannerCategoryObj = {
  status: 'Banner Status',
  approvedDate: 'Approved Date',
  bannerLive: 'Banner Live',
  bannerExpiresOn: 'Banner Expires On',
};

export const jdrrFrameDeliveryStatus = {
  create_artwork_date: 'Artwork Designed on',
  sent_to_printer_date: 'Frame Printed on',
  dispatch_artwork_date: 'Dispatched on',
  courier_podno: 'POD Number',
  courier_company: 'Delivery  Partner',
  '': 'Delivery Partner website',
};

export const jdrrBannerCategoryObj = {
  status: 'Banner Status',
  approved_date: 'Approved Date',
  banner_live: 'Banner Live',
  expired_on: 'Banner Expires On',
  city: 'City',
};

export const jdrrBannerCategoryObjGenio = {
  status: 'Banner Status',
  city: 'City',
};

export const bannerNotSignedListObj = {
  csportal: {
    webBannerNotSignedList: [
      'Get noticed & improve your brand value with the help of web banner. (desktop)',
      'Target specific audience relevant to your business category.',
      'Showcase your offers & pictures on design to attract potential customers.- Sign up for banner CLICK HERE',
    ],
    mobileBannerNotSignedList: [
      'Get noticed & improve your brand value with the help of mobile banner.',
      'Target specific audience relevant to your business category.',
      'Get quality hot leads for your business.- Sign up for banner CLICK HERE',
    ],
    jdrrBannerNotSignedList: [
      'Showcase framed reviews & ratings certificate to walk in customers.',
      'Get noticed & improve your brand value with the help of JDRR certificate.',
      'Sign up for banner CLICK HERE',
    ],
  },
  genio: {
    webBannerNotSignedList: [
      'Noticed & improved brand value with the help of web banner. (desktop)',
      'Target specific audience relevant to business category.',
      'To showcase offers & pictures on design to attract potential customers.',
    ],
    mobileBannerNotSignedList: [
      'Noticed & improved brand value with the help of mobile banner.',
      'Target specific audience relevant to business category.',
      'Quality hot leads for your business.',
    ],
    jdrrBannerNotSignedList: [
      'Showcase framed reviews & ratings certificate to walk in customers.',
      'Get noticed & improve your brand value with the help of JDRR certificate.',
      'To help user sign up for banner.',
    ],
  },
};

export const isValidEmail = (email) => {
  return typeof email === 'string' && email.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
};

export const isValidMobileNum = (num) => {
  return /^\d{10}$/.test(num);
};

export const defaultEnableBtnStyles = {
  backgroundColor: '#0076d7',
  border: `1px solid #E0E0E0`,
  transitionProperty: 'background-color, background-image, border-color, box-shadow',
  transition: 'all 0.8s',
  color: `#FFFFFF`,
  width: '140px',
};

export const getRatingImages = {
  TAP_TO_RATE: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/newprot_w/rating-tap-to-rate.svg',
  BAD: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/review_bad.svg',
  AVERAGE: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/review_average.svg',
  GOOD: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/review_good.svg',
  EXCELLENT: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/review_excellent.svg',
};

export const env = 'd';

export const pathsObj = {
  ecs: 'ECS',
  edit_business: 'Edit My Business',
  contract: 'My Contract Information',
  payment_history: 'Payments History',
  create_ticket: 'Raise a Complaint',
  grievance: 'Grievance Redressal',
  Healthcare: 'Healthcare',
  leads: 'Leads',
  payments: 'My Payments & Invoices',
  'Edit-my-Business': 'Edit My Business',
  'Website-App-Related': 'Website App Related',
  'JD-Pay': 'JD Pay',
  Leads: 'Leads',
  Payments: 'Payments & Invoices',
  Events: 'Events',
  UBL: 'UBL',
  LeadBank: 'LEAD BANK - B2B"',
  SmartAssistant: 'SMART ASSISTANT',
  jiohotstar: 'JIO-HOTSTAR CAMPAIGN',
  jdPartner: 'JD Partner',
  jdPartnerClient: 'JD Partner',
};

export const getContractTypeVal = (projectId) => {
  const storedValue = sessionStorage.getItem('contractType');

  if (projectId === 'csportal') {
    try {
      return JSON.parse(storedValue);
    } catch (e) {
      return storedValue;
    }
  } else {
    return storedValue;
  }
};

export const hasJdMartVertical = () => {
  const projectId = getProjectId();
  if (projectId === 'csportal') {
    const jdCorporateVertical = sessionStorage.getItem('jdCorporateVertical')
      ? JSON.parse(sessionStorage.getItem('jdCorporateVertical'))
      : '';
    return jdCorporateVertical === 'JD MART CORPORATE';
  }
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'))
    ? JSON.parse(sessionStorage.getItem('profileDetails'))
    : '';
  return profile?.department === 'Reseller';
};
export const allVerticalsParam = 'LISTING,RETENTION,CONTENT,JD MART CORPORATE,Design Banner,USER EXPERIENCE,GBL';

export const linksObj = {
  LEADS: {
    link: '/csportal/leads',
    title: 'Leads',
  },
  'DATA CHANGES/VALIDATION REQUEST': {
    link: '/csportal/edit_business',
    title: 'Edit my business',
  },
  'CONTRACT RELATED': {
    link: '/csportal/contract',
    title: 'My contract details',
  },
  ECS: {
    link: '/csportal/ecs',
    title: 'ECS',
  },
  'MOBILE BANNER RELATED': {
    link: '/csportal/banner',
    title: 'Banner',
  },
  'SPECIAL NUMBER ISSUE': {
    link: '/csportal/contract',
    title: 'My contract details',
  },
  'PAYMENTS & REFUNDS': {
    link: '/csportal/payments',
    title: 'My payments & invoices',
  },
};

export const DefaultErrMsg = 'Something went wrong';

export const handleJdPayRedirection = () => {
  const sourceVal = getSourceValue();
  const jdPayUrl = `https://wap.justdial.com/jdpay2/?page=faq&wkwebview=1&hide_header=1`;
  handleRedirection(sourceVal, jdPayUrl);
};

export const getECSFlag = () => {
  const storedValue = sessionStorage.getItem('ecsFlag');
  try {
    return JSON.parse(storedValue);
  } catch (e) {
    return storedValue;
  }
};

export const FILE_ICONS = {
  excel: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/excel-icon.svg',
  word: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/word-icon.svg',
  pdf: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/pdf-icon.svg',
  image: 'https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/image-icon.svg',
};

export const getFileIcon = (url = '') => {
  const u = url.toLowerCase();

  if (u.match(/\.(xls|xlsx|csv|xlsb)$/)) return FILE_ICONS.excel;
  if (u.match(/\.(doc|docx)$/)) return FILE_ICONS.word;
  if (u.match(/\.pdf$/)) return FILE_ICONS.pdf;
  if (u.match(/\.(jpg|jpeg|png|gif|svg|webp|jfif)$/)) return FILE_ICONS.image;

  return FILE_ICONS.image;
};

export const cancellationReasons = [
  'Business is Closed',
  'Money Problem/Not Interested',
  'Not Getting enough business/Poor Leads',
  'Wrong Promise made by Sales Person',
  'Money Deducted by mistake/Bank Issues',
  'Bought a New Package(Stop Old One)',
  'Poor Service',
  'Others',
];

const complaintReasonList = [
  'Commitment on JD Trusted / JD Verified',
  'Complaint Against Trust',
  'ECS Not Explained',
  'ECS Without Consent',
  'Stop TME /ME Calls',
  'Wrong Activation Commitment',
  'Wrong Leads Commitment',
  'Other',
];

const removeListingReasonList = [
  'Business Shutdown',
  'Poor Service',
  'Wrong Promise made by Sales Person',
  'Leads Issue',
  'Financial Issue',
  'Other',
];
const empList = ['10119890', '10191087', '10179794', '10191798', '10191797', '10091936'];

export {
  getUserType,
  userTypeTrackerObj,
  trackerObj,
  webSource,
  andriodSource,
  iosSource,
  touchSource,
  trackUserType,
  complaintReasonList,
  removeListingReasonList,
  empList,
};
